import { ref, onMounted, onBeforeUnmount, type Ref } from 'vue'

type Options = IntersectionObserverInit & { once?: boolean }

export function useInViewport<T extends HTMLElement>(
  options: Options = { threshold: 0, root: null, rootMargin: '0px', once: false }
) {
  const target: Ref<T | null> = ref(null)
  const isInViewport = ref(false)

  let observer: IntersectionObserver | null = null

  const stop = () => {
    if (observer) {
      observer.disconnect()
      observer = null
    }
  }

  onMounted(() => {
    if (typeof window === 'undefined') return // SSR guard

    observer = new IntersectionObserver((entries) => {
      const entry = entries[0]
      if (!entry) return
      isInViewport.value = entry.isIntersecting

      if (options.once && entry.isIntersecting) {
        stop()
      }
    }, options)

    if (target.value) observer.observe(target.value)
  })

  onBeforeUnmount(stop)

  return { target, isInViewport, stop }
}